import { ENUM_CASHBACK_STATUS, ENUM_USER_ACTIVE, ENUM_WELCOME_USER_STATUS } from "./enums";

export const testCasinoInfo = {
  casinoId: 5,
  casinoName: "Vulpin Casino",
  logoUrl: "https://fiat1.securebet.xyz/bot/logo/5-logo_vulpin.png",
  logoColor: "rgb(255, 193, 32)",
  buttonColor: "rgb(255, 193, 32)",
  headerColor: "#FFF00F",
  groupId: 21,
  telegramWidget: true,
  langList: "ru,en,uz,az,es,pt",
  langDefault: "ru",
  currencyDefault: "RUB",
  currencies: {
    RUB: { decimal: 0, type: "fiat" },
    EUR: { decimal: 2, type: "fiat" },
    UZS: { decimal: 0, type: "fiat" },
    USDT: { decimal: 2, type: "crypto" }
  },
  supportChat: "VulpinBotSupport2",
  channelUrl: "https://t.me/VulpinCasinoChannel",
  reviewUrl: "https://t.me/+wwQiO2u2rXc1NTI6",
  images: {
    main: {
      desktop: "",
      mobile: ""
    },
    menu: {
      desktop: "",
      mobile: ""
    },
    login: {
      desktop: "https://devf.securebet.xyz/bot/banners/6-login-desktop-На-вход-11.png",
      mobile: "https://devf.securebet.xyz/bot/banners/6-login-mobile-Вход-мобилка.png"
    },
    signup: {
      desktop: "https://devf.securebet.xyz/bot/banners/6-signup-desktop-Регистрация.png",
      mobile: "https://devf.securebet.xyz/bot/banners/6-signup-mobile-Регистрация-мобилка.png"
    }
  },
  langLink: {
    ru: {
      supportChat: "VulpinBotSupport2",
      channelUrl: "https://t.me/VulpinCasinoChannel",
      reviewUrl: "https://t.me/+wwQiO2u2rXc1NTI6",
      chatUrl: "https://t.me/+j9GgEuoWuqhhYWM8",
      tgPostUrl: "https://t.me/VulpinCasinoChannel/350",
      supportEmail: "@qqqqq@mmmm.com"
    },
    uz: {
      supportChat: "",
      channelUrl: "",
      reviewUrl: "",
      chatUrl: "https://t.me/+Q2U531fVFFBjMGIy",
      tgPostUrl: ""
    }
  },
  botName: "VulpinCasinoBot",
  htmlHead: "",
  htmlEndBody: "",
  excludeFromDemo: ["PGSoft", "Qilin"],
  gameCategories: [
    {
      id: 100,
      name: "3O0aks",
      providerId: 16,
      providerName: "3O0aks",
      games: [
        {
          game_id: 816,
          name: "15 Dragon Pearls",
          uuid: "6a6c1eb6155443449208f7fcfb76bc7c",
          source: "win2power:0",
          image:
            "https://r.gamesstatic.com/games/0c8c4534ac47f1e4d055425f16076983/3Oaks/6a6c1eb6155443449208f7fcfb76bc7c.png",
          type: "slots",
          provider: "Apollo games",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 815,
          name: "Wukong",
          uuid: "7d06f98541734ca9b0065adbfed864e8",
          source: "win2power:0",
          image:
            "https://r.gamesstatic.com/games/0c8c4534ac47f1e4d055425f16076983/3Oaks/7d06f98541734ca9b0065adbfed864e8.png",
          type: "slots",
          provider: "3Oaks",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        }
      ]
    },
    {
      id: 507,
      name: "Ezungi Live Games",
      providerId: 75,
      providerName: "Ezugi",
      games: [
        {
          game_id: 11434,
          name: "32 Cards",
          uuid: "05ff503ceb7715ec33fb738e17a0bd33",
          source: "win2power:1",
          image: "https://static.turnkey.casino/games/05ff503ceb7715ec33fb738e17a0bd33.png",
          type: "live dealer",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11420,
          name: "Andar Bahar",
          uuid: "fde78e89cbe69f90bbfea7f26f67b579477cf46b",
          source: "win2power:1",
          image: "https://static.turnkey.casino/games/fde78e89cbe69f90bbfea7f26f67b579477cf46b.png",
          type: "live dealer",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11426,
          name: "Auto Roulette",
          uuid: "7d608830b031b43cded3abbbb3719448adff3668",
          source: "win2power:1",
          image:
            "https://static.turnkey.casino/games/3962be5e18b1e84fdd95613e87dfda1a/Ezugi/7d608830b031b43cded3abbbb3719448adff3668.png",
          type: "roulette",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11492,
          name: "Auto Roulette 1",
          uuid: "970eb893a7f14a01904755890d51c4bd",
          source: "win2power:1",
          image:
            "https://static.turnkey.casino/games/3962be5e18b1e84fdd95613e87dfda1a/Ezugi/970eb893a7f14a01904755890d51c4bd.png",
          type: "roulette",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11423,
          name: "Baccarat",
          uuid: "f2da0e82e4b75724d2fffb51aca14434ddd6864b",
          source: "win2power:1",
          image: "https://static.turnkey.casino/games/f2da0e82e4b75724d2fffb51aca14434ddd6864b.png",
          type: "baccarat",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11491,
          name: "Baccarat A",
          uuid: "3749cfd8af044c0f8d61da9368d59199",
          source: "win2power:1",
          image:
            "https://static.turnkey.casino/games/3962be5e18b1e84fdd95613e87dfda1a/Ezugi/3749cfd8af044c0f8d61da9368d59199.png",
          type: "baccarat",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11490,
          name: "Baccarat B",
          uuid: "6f0b5af150714d929ae36a9348d1c971",
          source: "win2power:1",
          image:
            "https://static.turnkey.casino/games/3962be5e18b1e84fdd95613e87dfda1a/Ezugi/6f0b5af150714d929ae36a9348d1c971.png",
          type: "baccarat",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11489,
          name: "Baccarat D",
          uuid: "1b621a1622c7441580ecce6744527375",
          source: "win2power:1",
          image:
            "https://static.turnkey.casino/games/3962be5e18b1e84fdd95613e87dfda1a/Ezugi/1b621a1622c7441580ecce6744527375.png",
          type: "baccarat",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11488,
          name: "Baccarat E",
          uuid: "9f31a48512634391be9b2f0f6f9b97fb",
          source: "win2power:1",
          image:
            "https://static.turnkey.casino/games/3962be5e18b1e84fdd95613e87dfda1a/Ezugi/9f31a48512634391be9b2f0f6f9b97fb.png",
          type: "baccarat",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11431,
          name: "Baccarat no Commission",
          uuid: "2a799abeb40fe26896b46caa7a188d469481853f",
          source: "win2power:1",
          image: "https://static.turnkey.casino/games/2a799abeb40fe26896b46caa7a188d469481853f.png",
          type: "baccarat",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11429,
          name: "Baccarat Super 6",
          uuid: "ab2982dcbec79bb5731084e0cfb6220de2e504e6",
          source: "win2power:1",
          image: "https://static.turnkey.casino/games/ab2982dcbec79bb5731084e0cfb6220de2e504e6.png",
          type: "baccarat",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11421,
          name: "Bet on Teen Patti",
          uuid: "fe2133e298051c6474c34cc8754ecf9174df229b",
          source: "win2power:1",
          image: "https://static.turnkey.casino/games/fe2133e298051c6474c34cc8754ecf9174df229b.png",
          type: "live dealer",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11422,
          name: "Blackjack",
          uuid: "0e9e90471848524af0a2eb4ae1f7ca794655b452",
          source: "win2power:1",
          image: "https://static.turnkey.casino/games/0e9e90471848524af0a2eb4ae1f7ca794655b452.png",
          type: "blackjack",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11446,
          name: "Blackjack da Sorte",
          uuid: "1e3b723cb710c069008ed6f90ca96d825d3dfcb8",
          source: "win2power:1",
          image:
            "https://static.turnkey.casino/games/3962be5e18b1e84fdd95613e87dfda1a/Ezugi/1e3b723cb710c069008ed6f90ca96d825d3dfcb8.png",
          type: "blackjack",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11438,
          name: "Blackjack Salon Privé",
          uuid: "c743dc05bd242c74a46971d26de07fb8431b729d",
          source: "win2power:1",
          image: "https://static.turnkey.casino/games/c743dc05bd242c74a46971d26de07fb8431b729d.png",
          type: "live dealer",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11424,
          name: "Casino Hold'em",
          uuid: "5ffe9c022755838add76ff18161fbb83a8dade46",
          source: "win2power:1",
          image: "https://static.turnkey.casino/games/5ffe9c022755838add76ff18161fbb83a8dade46.png",
          type: "poker",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11444,
          name: "Casino Marina Andar Bahar",
          uuid: "3240527abe1a9c05f0bea138191a527624efaf14",
          source: "win2power:1",
          image:
            "https://static.turnkey.casino/games/3962be5e18b1e84fdd95613e87dfda1a/Ezugi/3240527abe1a9c05f0bea138191a527624efaf14.png",
          type: "andar bahar",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11487,
          name: "Casino Marina Baccarat A",
          uuid: "00285cc7d432468bb72203351e4f0bfc",
          source: "win2power:1",
          image:
            "https://static.turnkey.casino/games/3962be5e18b1e84fdd95613e87dfda1a/Ezugi/00285cc7d432468bb72203351e4f0bfc.png",
          type: "baccarat",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11486,
          name: "Casino Marina Baccarat B",
          uuid: "d38bf8fcafb04556ae12827463f0dc30",
          source: "win2power:1",
          image:
            "https://static.turnkey.casino/games/3962be5e18b1e84fdd95613e87dfda1a/Ezugi/d38bf8fcafb04556ae12827463f0dc30.png",
          type: "baccarat",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11485,
          name: "Casino Marina Baccarat C",
          uuid: "167a298be772415691eaa7247e0aa974",
          source: "win2power:1",
          image:
            "https://static.turnkey.casino/games/3962be5e18b1e84fdd95613e87dfda1a/Ezugi/167a298be772415691eaa7247e0aa974.png",
          type: "baccarat",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11484,
          name: "Casino Marina Baccarat D",
          uuid: "354690f14c7045b7aabd2bd80e98f52e",
          source: "win2power:1",
          image:
            "https://static.turnkey.casino/games/3962be5e18b1e84fdd95613e87dfda1a/Ezugi/354690f14c7045b7aabd2bd80e98f52e.png",
          type: "baccarat",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11483,
          name: "Casino Marina Roulette 1",
          uuid: "3c143ab458bc4c73a6bd84cf13c5cf72",
          source: "win2power:1",
          image:
            "https://static.turnkey.casino/games/3962be5e18b1e84fdd95613e87dfda1a/Ezugi/3c143ab458bc4c73a6bd84cf13c5cf72.png",
          type: "roulette",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11482,
          name: "Casino Marina Roulette 2",
          uuid: "171b14d98c5b492db59908cb14326ec3",
          source: "win2power:1",
          image:
            "https://static.turnkey.casino/games/3962be5e18b1e84fdd95613e87dfda1a/Ezugi/171b14d98c5b492db59908cb14326ec3.png",
          type: "roulette",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11481,
          name: "Cricket Auto Roulette",
          uuid: "96adab37c38048df9cecdf827835a45e",
          source: "win2power:1",
          image:
            "https://static.turnkey.casino/games/3962be5e18b1e84fdd95613e87dfda1a/Ezugi/96adab37c38048df9cecdf827835a45e.png",
          type: "roulette",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11436,
          name: "Cricket War",
          uuid: "60c52fae045b976a690a362a3b997f1ff1fa7346",
          source: "win2power:1",
          image: "https://static.turnkey.casino/games/60c52fae045b976a690a362a3b997f1ff1fa7346.png",
          type: "live dealer",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11454,
          name: "Diamond Roulette",
          uuid: "09e5c2c980534e1fb0b9762f7036497a",
          source: "win2power:1",
          image:
            "https://static.turnkey.casino/games/3962be5e18b1e84fdd95613e87dfda1a/Ezugi/09e5c2c980534e1fb0b9762f7036497a.png",
          type: "roulette",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11430,
          name: "Dragon Tiger",
          uuid: "87e83bc1a570341dd95461838912920f4ffec79c",
          source: "win2power:1",
          image: "https://static.turnkey.casino/games/87e83bc1a570341dd95461838912920f4ffec79c.png",
          type: "dragon tiger",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11447,
          name: "Dragon Tiger da Sorte",
          uuid: "c552dc42a4145147fce6addb033789290ca723dd",
          source: "win2power:1",
          image:
            "https://static.turnkey.casino/games/3962be5e18b1e84fdd95613e87dfda1a/Ezugi/c552dc42a4145147fce6addb033789290ca723dd.png",
          type: "dragon tiger",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11449,
          name: "EZ Dealer Roleta Brasileira",
          uuid: "5d838012775541e79120902ffd916c2e",
          source: "win2power:1",
          image:
            "https://static.turnkey.casino/games/3962be5e18b1e84fdd95613e87dfda1a/Ezugi/5d838012775541e79120902ffd916c2e.png",
          type: "roulette",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11480,
          name: "EZ Dealer Roulette English",
          uuid: "bd69db2ccace4827aa45f158d1b8cbec",
          source: "win2power:1",
          image:
            "https://static.turnkey.casino/games/3962be5e18b1e84fdd95613e87dfda1a/Ezugi/bd69db2ccace4827aa45f158d1b8cbec.png",
          type: "roulette",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11479,
          name: "EZ Dealer Roulette Japanese",
          uuid: "6978e57577bb4e72b0dd9370e3fea119",
          source: "win2power:1",
          image:
            "https://static.turnkey.casino/games/3962be5e18b1e84fdd95613e87dfda1a/Ezugi/6978e57577bb4e72b0dd9370e3fea119.png",
          type: "roulette",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11478,
          name: "EZ Dealer Roulette Mandarin",
          uuid: "9f02e53013d240ee84de8bebd117c65d",
          source: "win2power:1",
          image:
            "https://static.turnkey.casino/games/3962be5e18b1e84fdd95613e87dfda1a/Ezugi/9f02e53013d240ee84de8bebd117c65d.png",
          type: "roulette",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11440,
          name: "EZ Dealer Roulette Thai",
          uuid: "d5551890469542d199cf59e5cf4969a2",
          source: "win2power:1",
          image:
            "https://static.turnkey.casino/games/3962be5e18b1e84fdd95613e87dfda1a/Ezugi/d5551890469542d199cf59e5cf4969a2.png",
          type: "roulette",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11477,
          name: "Football Auto Roulette",
          uuid: "500adadf88164f15b243a8f03cc09f7d",
          source: "win2power:1",
          image:
            "https://static.turnkey.casino/games/3962be5e18b1e84fdd95613e87dfda1a/Ezugi/500adadf88164f15b243a8f03cc09f7d.png",
          type: "roulette",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11476,
          name: "Gold Blackjack 1",
          uuid: "f6b69f7e37414553bfb37d37f71642fa",
          source: "win2power:1",
          image:
            "https://static.turnkey.casino/games/3962be5e18b1e84fdd95613e87dfda1a/Ezugi/f6b69f7e37414553bfb37d37f71642fa.png",
          type: "blackjack",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11475,
          name: "Gold Blackjack 3",
          uuid: "f9a89f081fcc4b6aab235f7465fff4c6",
          source: "win2power:1",
          image:
            "https://static.turnkey.casino/games/3962be5e18b1e84fdd95613e87dfda1a/Ezugi/f9a89f081fcc4b6aab235f7465fff4c6.png",
          type: "blackjack",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11474,
          name: "Gold Blackjack 5",
          uuid: "b783a5ce009644b39cf334ddadf6ad4c",
          source: "win2power:1",
          image:
            "https://static.turnkey.casino/games/3962be5e18b1e84fdd95613e87dfda1a/Ezugi/b783a5ce009644b39cf334ddadf6ad4c.png",
          type: "blackjack",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11473,
          name: "Italian Roulette",
          uuid: "cbad04cc0a364db482a20e9989e24302",
          source: "win2power:1",
          image:
            "https://static.turnkey.casino/games/3962be5e18b1e84fdd95613e87dfda1a/Ezugi/cbad04cc0a364db482a20e9989e24302.png",
          type: "roulette",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11442,
          name: "Knockout Baccarat",
          uuid: "d1393b134e7c7cba068edf9ff8fc71a5f1b9f15c",
          source: "win2power:1",
          image:
            "https://static.turnkey.casino/games/3962be5e18b1e84fdd95613e87dfda1a/Ezugi/d1393b134e7c7cba068edf9ff8fc71a5f1b9f15c.png",
          type: "baccarat",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11432,
          name: "LUCKY 7",
          uuid: "fa5c7dd0da8b33be447c5c09b5668e233294e9da",
          source: "win2power:1",
          image: "https://static.turnkey.casino/games/fa5c7dd0da8b33be447c5c09b5668e233294e9da.png",
          type: "live dealer",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11450,
          name: "Namaste Roulette",
          uuid: "99f2d694929c4af9bc4a30e0c6d7f0c5",
          source: "win2power:1",
          image:
            "https://static.turnkey.casino/games/3962be5e18b1e84fdd95613e87dfda1a/Ezugi/99f2d694929c4af9bc4a30e0c6d7f0c5.png",
          type: "roulette",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11472,
          name: "No Commission Baccarat A",
          uuid: "0cbd3e5d08d141439a34e475c1426416",
          source: "win2power:1",
          image:
            "https://static.turnkey.casino/games/3962be5e18b1e84fdd95613e87dfda1a/Ezugi/0cbd3e5d08d141439a34e475c1426416.png",
          type: "baccarat",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11471,
          name: "No Commission Baccarat B",
          uuid: "4209f42e70194986a69535889040aaa1",
          source: "win2power:1",
          image:
            "https://static.turnkey.casino/games/3962be5e18b1e84fdd95613e87dfda1a/Ezugi/4209f42e70194986a69535889040aaa1.png",
          type: "baccarat",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11470,
          name: "Baccarat D (No Commission)",
          uuid: "41392bd92cf6461aad28ec50b7fb7855",
          source: "win2power:1",
          image:
            "https://static.turnkey.casino/games/3962be5e18b1e84fdd95613e87dfda1a/Ezugi/41392bd92cf6461aad28ec50b7fb7855.png",
          type: "baccarat",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11469,
          name: "No Commission Baccarat E",
          uuid: "691bae0e35f04b86bbc059d053ff54e7",
          source: "win2power:1",
          image:
            "https://static.turnkey.casino/games/3962be5e18b1e84fdd95613e87dfda1a/Ezugi/691bae0e35f04b86bbc059d053ff54e7.png",
          type: "baccarat",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11437,
          name: "One Day Teen Patti",
          uuid: "ea458c4f2a88cd811b47f27d915d8efd6e334815",
          source: "win2power:1",
          image: "https://static.turnkey.casino/games/ea458c4f2a88cd811b47f27d915d8efd6e334815.png",
          type: "live dealer",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11468,
          name: "Oracle 360 Roulette",
          uuid: "464b1a2151d445d480b294a489b01ef7",
          source: "win2power:1",
          image:
            "https://static.turnkey.casino/games/3962be5e18b1e84fdd95613e87dfda1a/Ezugi/464b1a2151d445d480b294a489b01ef7.png",
          type: "roulette",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11467,
          name: "Oracle Real Roulette",
          uuid: "5d2759665f35429da4373e9c4c4890f2",
          source: "win2power:1",
          image:
            "https://static.turnkey.casino/games/3962be5e18b1e84fdd95613e87dfda1a/Ezugi/5d2759665f35429da4373e9c4c4890f2.png",
          type: "roulette",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11452,
          name: "Prestige Auto Roulette",
          uuid: "dd76fd8d9a4f4a179c4ae722243d6715",
          source: "win2power:1",
          image:
            "https://static.turnkey.casino/games/3962be5e18b1e84fdd95613e87dfda1a/Ezugi/dd76fd8d9a4f4a179c4ae722243d6715.png",
          type: "roulette",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11494,
          name: "Revolution Roulette",
          uuid: "99d66862285e9b4dcce91690cfe46390bfa9aa4a",
          source: "win2power:1",
          image:
            "https://static.turnkey.casino/games/3962be5e18b1e84fdd95613e87dfda1a/Ezugi/99d66862285e9b4dcce91690cfe46390bfa9aa4a.png",
          type: "slots",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11445,
          name: "Roleta da Sorte",
          uuid: "2cfad95d4de44edd1fd013ee5a6ba3caca614077",
          source: "win2power:1",
          image:
            "https://static.turnkey.casino/games/3962be5e18b1e84fdd95613e87dfda1a/Ezugi/2cfad95d4de44edd1fd013ee5a6ba3caca614077.png",
          type: "roulette",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11425,
          name: "Roulette",
          uuid: "3a120c12e78edbf77a954ec8a1d5d97be6b09fe8",
          source: "win2power:1",
          image: "https://static.turnkey.casino/games/3a120c12e78edbf77a954ec8a1d5d97be6b09fe8.png",
          type: "roulette",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11433,
          name: "Roulette Portomaso 2",
          uuid: "b85eedcd644a81d2709e35f59984a03a49784d83",
          source: "win2power:1",
          image:
            "https://static.turnkey.casino/games/3962be5e18b1e84fdd95613e87dfda1a/Ezugi/b85eedcd644a81d2709e35f59984a03a49784d83.png",
          type: "roulette",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11448,
          name: "Ruleta del Sol",
          uuid: "637346de5f001e55e3737987d5400b4e5b1213a8",
          source: "win2power:1",
          image:
            "https://static.turnkey.casino/games/3962be5e18b1e84fdd95613e87dfda1a/Ezugi/637346de5f001e55e3737987d5400b4e5b1213a8.jpg",
          type: "roulette",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11466,
          name: "Rumba Blackjack 1",
          uuid: "4f4b415dcc3e48179ba49bbe080b2f75",
          source: "win2power:1",
          image:
            "https://static.turnkey.casino/games/3962be5e18b1e84fdd95613e87dfda1a/Ezugi/4f4b415dcc3e48179ba49bbe080b2f75.png",
          type: "blackjack",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11465,
          name: "Rumba Blackjack 2",
          uuid: "5ced2cd7d22e4636832f7d041390a45f",
          source: "win2power:1",
          image:
            "https://static.turnkey.casino/games/3962be5e18b1e84fdd95613e87dfda1a/Ezugi/5ced2cd7d22e4636832f7d041390a45f.png",
          type: "blackjack",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11464,
          name: "Rumba Blackjack 3",
          uuid: "b8f2fe417fe745358a2f4ebaf8e99103",
          source: "win2power:1",
          image:
            "https://static.turnkey.casino/games/3962be5e18b1e84fdd95613e87dfda1a/Ezugi/b8f2fe417fe745358a2f4ebaf8e99103.png",
          type: "blackjack",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11463,
          name: "Rumba Blackjack 4",
          uuid: "ad55d202b9b5466cbd18d18ab61acb83",
          source: "win2power:1",
          image:
            "https://static.turnkey.casino/games/3962be5e18b1e84fdd95613e87dfda1a/Ezugi/ad55d202b9b5466cbd18d18ab61acb83.png",
          type: "blackjack",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11435,
          name: "Sic Bo",
          uuid: "b23a4ab032c88e206ed066b54db51371489d1a90",
          source: "win2power:1",
          image: "https://static.turnkey.casino/games/b23a4ab032c88e206ed066b54db51371489d1a90.png",
          type: "live dealer",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11493,
          name: "Skyline Roulette",
          uuid: "a74169e93f8fbb8c0d6fa96f75e2e76a72559132",
          source: "win2power:1",
          image:
            "https://static.turnkey.casino/games/3962be5e18b1e84fdd95613e87dfda1a/Ezugi/a74169e93f8fbb8c0d6fa96f75e2e76a72559132.png",
          type: "roulette",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11461,
          name: "Spanish Roulette",
          uuid: "4066d46642b147de81b53ec1edf78813",
          source: "win2power:1",
          image:
            "https://static.turnkey.casino/games/3962be5e18b1e84fdd95613e87dfda1a/Ezugi/4066d46642b147de81b53ec1edf78813.png",
          type: "roulette",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11462,
          name: "Spanish Unlimited Blackjack",
          uuid: "e3aa0fbaac214478ae53f005c4e12159",
          source: "win2power:1",
          image:
            "https://static.turnkey.casino/games/3962be5e18b1e84fdd95613e87dfda1a/Ezugi/e3aa0fbaac214478ae53f005c4e12159.png",
          type: "blackjack",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11460,
          name: "Speed Auto Roulette",
          uuid: "86f8cb4fa19d45878755a6a63b2b23c4",
          source: "win2power:1",
          image:
            "https://static.turnkey.casino/games/3962be5e18b1e84fdd95613e87dfda1a/Ezugi/86f8cb4fa19d45878755a6a63b2b23c4.png",
          type: "roulette",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11451,
          name: "Speed Roulette",
          uuid: "17e8185f0a3944389d4d431706277e42",
          source: "win2power:1",
          image:
            "https://static.turnkey.casino/games/3962be5e18b1e84fdd95613e87dfda1a/Ezugi/17e8185f0a3944389d4d431706277e42.png",
          type: "roulette",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11428,
          name: "Teen Patti",
          uuid: "cac88d6f80950224007a2d90ad58d5f8c991b72d",
          source: "win2power:1",
          image: "https://static.turnkey.casino/games/cac88d6f80950224007a2d90ad58d5f8c991b72d.png",
          type: "live dealer",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11459,
          name: "Turkish Roulette",
          uuid: "ccde094566c94211aff44d1ce6c495bc",
          source: "win2power:1",
          image:
            "https://static.turnkey.casino/games/3962be5e18b1e84fdd95613e87dfda1a/Ezugi/ccde094566c94211aff44d1ce6c495bc.png",
          type: "roulette",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11441,
          name: "Ultimate Andar Bahar",
          uuid: "89666aedbbfac99340e04576657bbfc40c4cb9f3",
          source: "win2power:1",
          image:
            "https://static.turnkey.casino/games/3962be5e18b1e84fdd95613e87dfda1a/Ezugi/89666aedbbfac99340e04576657bbfc40c4cb9f3.png",
          type: "andar bahar",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11443,
          name: "Ultimate Roulette",
          uuid: "36e79031547ecd7e36bac46f0671652d49cce727",
          source: "win2power:1",
          image:
            "https://static.turnkey.casino/games/3962be5e18b1e84fdd95613e87dfda1a/Ezugi/36e79031547ecd7e36bac46f0671652d49cce727.png",
          type: "roulette",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11439,
          name: "Ultimate Sic Bo",
          uuid: "540a4b3aeed3bd80bd96a57afc378703a90350ff",
          source: "win2power:1",
          image: "https://static.turnkey.casino/games/540a4b3aeed3bd80bd96a57afc378703a90350ff.png",
          type: "sic bo",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11427,
          name: "Unlimited Blackjack",
          uuid: "802e0279619f46a9250a134e40e795606f493329",
          source: "win2power:1",
          image: "https://static.turnkey.casino/games/802e0279619f46a9250a134e40e795606f493329.png",
          type: "blackjack",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11458,
          name: "Unlimited Blackjack 1",
          uuid: "d10b3a1d0152430ca6cd06e82c165f27",
          source: "win2power:1",
          image:
            "https://static.turnkey.casino/games/3962be5e18b1e84fdd95613e87dfda1a/Ezugi/d10b3a1d0152430ca6cd06e82c165f27.png",
          type: "blackjack",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11457,
          name: "VIP Diamond Blackjack",
          uuid: "a7904fe8c88f4bd48ddf8937702cc62c",
          source: "win2power:1",
          image:
            "https://static.turnkey.casino/games/3962be5e18b1e84fdd95613e87dfda1a/Ezugi/a7904fe8c88f4bd48ddf8937702cc62c.png",
          type: "blackjack",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11453,
          name: "VIP Fortune Baccarat",
          uuid: "fe3ba47383d246249918e84c1451ce80",
          source: "win2power:1",
          image:
            "https://static.turnkey.casino/games/3962be5e18b1e84fdd95613e87dfda1a/Ezugi/fe3ba47383d246249918e84c1451ce80.png",
          type: "baccarat",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11456,
          name: "VIP Roulette",
          uuid: "4ea7451a27964feaa3955fb179cb0f27",
          source: "win2power:1",
          image:
            "https://static.turnkey.casino/games/3962be5e18b1e84fdd95613e87dfda1a/Ezugi/4ea7451a27964feaa3955fb179cb0f27.png",
          type: "roulette",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 11455,
          name: "VIP Surrender Blackjack",
          uuid: "bd3eff1628704b88bd9e7e65cc6a874f",
          source: "win2power:1",
          image:
            "https://static.turnkey.casino/games/3962be5e18b1e84fdd95613e87dfda1a/Ezugi/bd3eff1628704b88bd9e7e65cc6a874f.png",
          type: "blackjack",
          provider: "Ezugi",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        }
      ]
    },
    {
      id: 101,
      name: "Аматик",
      providerId: 13,
      providerName: "Amatic",
      games: [
        {
          game_id: 577,
          name: "Admiral Nelson",
          uuid: "71f8a9c71b524e34bab494ab71d89b34",
          source: "win2power:0",
          image:
            "https://r.gamesstatic.com/games/0c8c4534ac47f1e4d055425f16076983/Amatic/71f8a9c71b524e34bab494ab71d89b34.jpg",
          type: "slots",
          provider: "Amatic",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 602,
          name: "Royal Unicorn",
          uuid: "e9368eb68f8b4fcd855e68b7887ae5e9",
          source: "win2power:0",
          image:
            "https://r.gamesstatic.com/games/0c8c4534ac47f1e4d055425f16076983/Amatic/e9368eb68f8b4fcd855e68b7887ae5e9.png",
          type: "slots",
          provider: "Amatic",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 601,
          name: "Wild Dragon",
          uuid: "071cfc095cb447309b08792aeef3950a",
          source: "win2power:0",
          image:
            "https://r.gamesstatic.com/games/0c8c4534ac47f1e4d055425f16076983/Amatic/071cfc095cb447309b08792aeef3950a.png",
          type: "slots",
          provider: "Amatic",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        }
      ]
    },
    {
      id: 102,
      name: "Аппарат",
      providerId: 59,
      providerName: "Apparat",
      games: [
        {
          game_id: 2038,
          name: "1-2-3 Wilds on Fire",
          uuid: "e66147aed56740438dc30cb2b962aa59",
          source: "win2power:1",
          image: "https://static.turnkey.casino/games/Apparat/e66147aed56740438dc30cb2b962aa59.png",
          type: "slots",
          provider: "Apparat",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 2019,
          name: "The Griffin",
          uuid: "92aa3c163b53429fb5fc25e8cdf98d49",
          source: "win2power:1",
          image: "https://static.turnkey.casino/games/Apparat/92aa3c163b53429fb5fc25e8cdf98d49.png",
          type: "slots",
          provider: "Apparat",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 2017,
          name: "The Guardian God Heimdall's Horn",
          uuid: "16cdc9fcf5aa409d9232ac488546dac8",
          source: "win2power:1",
          image: "https://static.turnkey.casino/games/Apparat/16cdc9fcf5aa409d9232ac488546dac8.png",
          type: "slots",
          provider: "Apparat",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 2011,
          name: "The Warlock's Book",
          uuid: "5b4ad38ee5e844cc88a1d34c5ff947bb",
          source: "win2power:1",
          image: "https://static.turnkey.casino/games/Apparat/5b4ad38ee5e844cc88a1d34c5ff947bb.png",
          type: "slots",
          provider: "Apparat",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 2047,
          name: "The Warlock's Book - Buy Feature",
          uuid: "ec269bc9a36e4af08c267e9e9cf07a1e",
          source: "win2power:1",
          image: "https://static.turnkey.casino/games/Apparat/ec269bc9a36e4af08c267e9e9cf07a1e.png",
          type: "slots",
          provider: "Apparat",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 2010,
          name: "Total Eclipse",
          uuid: "80c8217fb4524766b09ddcfec022651d",
          source: "win2power:1",
          image: "https://static.turnkey.casino/games/Apparat/80c8217fb4524766b09ddcfec022651d.png",
          type: "slots",
          provider: "Apparat",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 2040,
          name: "Total Eclipse - Buy Feature",
          uuid: "fdc8c8d423484e21a3be174648a48d4a",
          source: "win2power:1",
          image: "https://static.turnkey.casino/games/Apparat/fdc8c8d423484e21a3be174648a48d4a.png",
          type: "slots",
          provider: "Apparat",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 2031,
          name: "Total Eclipse XXL",
          uuid: "d6667ea087cb4c23b3ae6a7a4d14547f",
          source: "win2power:1",
          image: "https://static.turnkey.casino/games/Apparat/d6667ea087cb4c23b3ae6a7a4d14547f.png",
          type: "slots",
          provider: "Apparat",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 2025,
          name: "Valkyries",
          uuid: "2a6ea3df3413a744b84ad2f538d8c8b42afbb708",
          source: "win2power:1",
          image:
            "https://static.turnkey.casino/games/Apparat/2a6ea3df3413a744b84ad2f538d8c8b42afbb708.png",
          type: "slots",
          provider: "Apparat",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 1
        }
      ]
    },
    {
      id: 103,
      name: "Аватар",
      providerId: 64,
      providerName: "AvatarUX",
      games: [
        {
          game_id: 2077,
          name: "80sPOP",
          uuid: "8eb58826e3794642b14dd3473a58ecab",
          source: "win2power:1",
          image:
            "https://static.turnkey.casino/games/AvatarUX/8eb58826e3794642b14dd3473a58ecab.png",
          type: "slots",
          provider: "AvatarUX",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 2054,
          name: "Witchy POPpins",
          uuid: "c0654d53da2d4774b1abcdc14a2d6569",
          source: "win2power:1",
          image:
            "https://static.turnkey.casino/games/AvatarUX/c0654d53da2d4774b1abcdc14a2d6569.png",
          type: "slots",
          provider: "AvatarUX",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 2076,
          name: "Worms Of Valor",
          uuid: "319d998059b849958fa204b191448003",
          source: "win2power:1",
          image:
            "https://static.turnkey.casino/games/AvatarUX/319d998059b849958fa204b191448003.png",
          type: "slots",
          provider: "AvatarUX",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 2064,
          name: "Zombie APOPlypse",
          uuid: "59108cdbc3bc4b129062dde760f31602",
          source: "win2power:1",
          image:
            "https://static.turnkey.casino/games/AvatarUX/59108cdbc3bc4b129062dde760f31602.png",
          type: "slots",
          provider: "AvatarUX",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        }
      ]
    },
    {
      id: 104,
      name: "Авиатрикс",
      providerId: 60,
      providerName: "Aviatrix",
      games: [
        {
          game_id: 942,
          name: "Aviatrix",
          uuid: "9d9b5b34389337d4e43568b4ba2d56be97de447a",
          source: "win2power:1",
          image:
            "https://static.turnkey.casino/games/Aviatrix/9d9b5b34389337d4e43568b4ba2d56be97de447a.png",
          type: "crash",
          provider: "Aviatrix",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 1
        }
      ]
    },
    {
      id: 105,
      name: "БФГеймс",
      providerId: 47,
      providerName: "BFGames",
      games: [
        {
          game_id: 2207,
          name: "Alice In Wonderland",
          uuid: "9859b5135dc04af19fb718c721151a0f",
          source: "win2power:1",
          image: "https://static.turnkey.casino/games/BFGames/9859b5135dc04af19fb718c721151a0f.png",
          type: "slots",
          provider: "BFGames",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        },
        {
          game_id: 1893,
          name: "Wilds and Pirates Mobile",
          uuid: "76c78b4996de437d9d0a371477ead069",
          source: "win2power:1",
          image:
            "https://static.turnkey.casino/games/ZeusPlay/76c78b4996de437d9d0a371477ead069.png",
          type: "slots",
          provider: "ZeusPlay",
          priority: 1,
          favorites: false,
          enabled: 1,
          hit: 0
        }
      ]
    }
  ],
  bonusGames: [
    {
      id: 3,
      name: "Lucky Lady’s Charm",
      url: "/js-games/lucky_lady/game.html"
    },
    {
      id: 5,
      name: "Fruit Cocktail",
      url: "/js-games/fruit_cocktail/game.html"
    },
    {
      id: 2,
      name: "Book of Ra Classic",
      url: "/js-games/book_of_ra_classic/game.html"
    },
    {
      id: 40,
      name: "Lord of Ocean",
      url: "/js-games/lord_of_ocean/game.html"
    },
    {
      id: 23,
      name: "Sharky",
      url: "/js-games/sharky/game.html"
    },
    {
      id: 19,
      name: "Beetle Mania Deluxe",
      url: "/js-games/beetle_mania/game.html"
    },
    {
      id: 36,
      name: "Book of Ra Deluxe",
      url: "/js-games/book-of-ra-deluxe-2/game.html"
    },
    {
      id: 20,
      name: "Sizzling Hot Deluxe",
      url: "/js-games/sizzling_hot_deluxe/game.html"
    },
    {
      id: 48,
      name: "Diamond 7",
      url: "/js-games/diamond7/game.html"
    },
    {
      id: 18,
      name: "Just Jewels Deluxe",
      url: "/js-games/just_jewels_deluxe/game.html"
    },
    {
      id: 44,
      name: "Lucky Lady’s Charm",
      url: "/js-games/lucky_lady_deluxe/game.html"
    },
    {
      id: 45,
      name: "Queens of Hearts",
      url: "/js-games/queen_of_hearts/game.html"
    }
  ],
  gameHits: [
    {
      game_id: 817,
      name: "3 Coins",
      uuid: "a7be71ce60f34c78b72bb728c6cf2e0c",
      source: "win2power:0",
      image:
        "https://r.gamesstatic.com/games/0c8c4534ac47f1e4d055425f16076983/3Oaks/a7be71ce60f34c78b72bb728c6cf2e0c.png",
      type: "slots",
      provider: "3Oaks",
      excludeDemoMode: false
    },
    {
      game_id: 802,
      name: "Sticky Piggy",
      uuid: "1e5e042292d240fd827cee79720ddc65",
      source: "win2power:0",
      image:
        "https://r.gamesstatic.com/games/0c8c4534ac47f1e4d055425f16076983/3Oaks/1e5e042292d240fd827cee79720ddc65.png",
      type: "slots",
      provider: "3Oaks",
      excludeDemoMode: false
    },
    {
      game_id: 2025,
      name: "Valkyries",
      uuid: "2a6ea3df3413a744b84ad2f538d8c8b42afbb708",
      source: "win2power:1",
      image:
        "https://static.turnkey.casino/games/Apparat/2a6ea3df3413a744b84ad2f538d8c8b42afbb708.png",
      type: "slots",
      provider: "Apparat",
      excludeDemoMode: false
    },
    {
      game_id: 942,
      name: "Aviatrix",
      uuid: "9d9b5b34389337d4e43568b4ba2d56be97de447a",
      source: "win2power:1",
      image:
        "https://static.turnkey.casino/games/Aviatrix/9d9b5b34389337d4e43568b4ba2d56be97de447a.png",
      type: "crash",
      provider: "Aviatrix",
      excludeDemoMode: false
    },
    {
      game_id: 2222,
      name: "Book of Gods",
      uuid: "515cbd3d87a3402b8a08f5a452fd64cd",
      source: "win2power:1",
      image: "https://static.turnkey.casino/games/BFGames/515cbd3d87a3402b8a08f5a452fd64cd.png",
      type: "slots",
      provider: "BFGames",
      excludeDemoMode: false
    },
    {
      game_id: 2123,
      name: "7 Fruits",
      uuid: "16e052082e546654d9c21cf6c00c9644da9b650e",
      source: "win2power:1",
      image: "https://static.turnkey.casino/games/16e052082e546654d9c21cf6c00c9644da9b650e.png",
      type: "slots",
      provider: "Belatra Games",
      excludeDemoMode: false
    },
    {
      game_id: 2506,
      name: "Beer Bonanza",
      uuid: "ac437469dda9d4e0a82059d405540eec85d111d2",
      source: "win2power:1",
      image: "https://static.turnkey.casino/games/ac437469dda9d4e0a82059d405540eec85d111d2.png",
      type: "slots",
      provider: "BGaming",
      excludeDemoMode: false
    },
    {
      game_id: 3059,
      name: "777 Deluxe",
      uuid: "515fc4e58e8e4084b46f23d50f355ecb",
      source: "win2power:1",
      image:
        "https://static.turnkey.casino/games/3962be5e18b1e84fdd95613e87dfda1a/Blueprint/515fc4e58e8e4084b46f23d50f355ecb.png",
      type: "slots",
      provider: "Blueprint",
      excludeDemoMode: false
    },
    {
      game_id: 4134,
      name: "Fire dragon",
      uuid: "1560f2cf9eb84418a45ca610b646fc24",
      source: "win2power:1",
      image: "https://static.turnkey.casino/games/FBastards/1560f2cf9eb84418a45ca610b646fc24.png",
      type: "slots",
      provider: "FBastards",
      excludeDemoMode: false
    },
    {
      game_id: 4140,
      name: "Mafia",
      uuid: "925d3b2e85f945d98800e3dacbf0c41b",
      source: "win2power:1",
      image: "https://static.turnkey.casino/games/FBastards/925d3b2e85f945d98800e3dacbf0c41b.png",
      type: "slots",
      provider: "FBastards",
      excludeDemoMode: false
    },
    {
      game_id: 127,
      name: "Sizzling 6",
      uuid: "e355fffe8405129a5ef8b6a5e77ff83d0a118de4",
      source: "win2power:0",
      image: "https://r.gamesstatic.com/games/e355fffe8405129a5ef8b6a5e77ff83d0a118de4.jpg",
      type: "slots",
      provider: "Greentube",
      excludeDemoMode: false
    },
    {
      game_id: 124,
      name: "Sizzling Hot Deluxe",
      uuid: "557af416d9831dccc0bd5fdfe47eaa41c60015ad",
      source: "win2power:0",
      image: "https://r.gamesstatic.com/games/557af416d9831dccc0bd5fdfe47eaa41c60015ad.jpg",
      type: "slots",
      provider: "Greentube",
      excludeDemoMode: false
    },
    {
      game_id: 1606,
      name: "Big Bass - Hold & Spinner",
      uuid: "46fd364683164ddbb528466ff23987e1",
      source: "win2power:1",
      image:
        "https://static.turnkey.casino/games/PragmaticPlay/46fd364683164ddbb528466ff23987e1.png",
      type: "slots",
      provider: "PragmaticPlay",
      excludeDemoMode: false
    },
    {
      game_id: 1530,
      name: "Big Bass - Keeping it Reel",
      uuid: "d1acf2e3d4bce1feaa8e86c73521b5337322b509",
      source: "win2power:1",
      image:
        "https://static.turnkey.casino/games/PragmaticPlay/d1acf2e3d4bce1feaa8e86c73521b5337322b509.png",
      type: "slots",
      provider: "PragmaticPlay",
      excludeDemoMode: false
    },
    {
      game_id: 1288,
      name: "Big Bass Bonanza",
      uuid: "76b3846996214fa09c1f761a0228c032",
      source: "win2power:1",
      image:
        "https://static.turnkey.casino/games/PragmaticPlay/76b3846996214fa09c1f761a0228c032.png",
      type: "slots",
      provider: "PragmaticPlay",
      excludeDemoMode: false
    },
    {
      game_id: 1884,
      name: "Big Bass Double Down Deluxe",
      uuid: "bf03ab99344f46b8ab2af03005e722bf",
      source: "win2power:1",
      image:
        "https://static.turnkey.casino/games/PragmaticPlay/bf03ab99344f46b8ab2af03005e722bf.png",
      type: "slots",
      provider: "PragmaticPlay",
      excludeDemoMode: false
    },
    {
      game_id: 1382,
      name: "Big Juan",
      uuid: "922337fede347c8bb8e0e273a4f06dc99f04bd9c",
      source: "win2power:1",
      image: "https://static.turnkey.casino/games/922337fede347c8bb8e0e273a4f06dc99f04bd9c.png",
      type: "slots",
      provider: "PragmaticPlay",
      excludeDemoMode: false
    },
    {
      game_id: 1058,
      name: "The Dog House Megaways",
      uuid: "b3a22c28284e4de69efb358940838cb1",
      source: "win2power:1",
      image:
        "https://static.turnkey.casino/games/PragmaticPlay/b3a22c28284e4de69efb358940838cb1.png",
      type: "slots",
      provider: "PragmaticPlay",
      excludeDemoMode: false
    }
  ],
  banners: [
    {
      id: 13,
      name: "Видео баннеры",
      position: 1,
      language: "ru",
      gameType: 0,
      gameId: 0,
      bannerText: "",
      relativeUrl: "",
      externalUrl: "",
      fileUrl: "https://devf.securebet.xyz/images/banners/03.webm",
      mobileFileUrl: "https://devf.securebet.xyz/images/banners/01.webm"
    },
    {
      id: 3,
      name: "20% cashback",
      position: 2,
      language: "ru",
      gameType: 0,
      gameId: 0,
      bannerText:
        "<p><b>КЕШБЭК 20% КАЖДЫЙ ДЕНЬ!</b></p><p><br></p><p><u>Дарим кешбэк 20% на каждый депозит и каждый день без вейджера!</u></p><p><br></p><p><b>Шаги:</b></p><p>1) Сделай депозит на любую сумму;</p><p>2) Получи <b>20%</b> от суммы всех твои депозитов за календарный день.</p><p><br></p><p><b>Условия акции:</b></p><p>1) Для участия необходимо сделать 1 депозит или несколько депозитов в течение одного календарного дня;</p><p>2) По сумме всех депозитов за календарный день будет начислен кешбэк 20% от суммы всех депозитов;</p><p>3) Вейджер кешбэка - 0;</p><p>4) Кешбэк начисляется на следующий календарь день до 13:00 (UTC +3);</p><p>5) После начисления кешбэк сразу доступен к выводу;</p><p>6) Максимальная сумма кешбэка не ограничена;</p><p>7) При подозрении на мошеннические действия и при попытках обмана, Slotohub имеет право не начислять бонус.</p>",
      relativeUrl: "daily_cashback",
      externalUrl: "",
      fileUrl: "https://fiat1.securebet.xyz/images/banners/photo_2024-06-29-16.20.17.png",
      mobileFileUrl: "https://fiat1.securebet.xyz/images/banners/photo_2024-06-29-16.19.51 (1).png",
      makeBotLink: false
    },
    {
      id: 45,
      name: "100% бонус на первый депозит",
      position: 2,
      language: "ru",
      gameType: 0,
      gameId: 0,
      bannerText:
        "100% бонус на первый депозит до 250000 рублей!Шаги:1) Сделай депозит от 300 рублей;2) Получи 100% от суммы твоего первого депозита до 250000 рублей.Условия акции:1) Для участия в акции необходимо сделать депозит от 300 рублей;2) Минимальная сумма бонуса - 300 рублей, максимальная - 250000 рублей;3) Бонус начисляется 100% от суммы первого депозита (например, при пополнении на 1000 рублей, будет начислен бонус в размере 1000 рублей);4) Бонус начисляется автоматически после совершения успешного депозита;5) Вейджер бонуса - 30х, кешаут бонуса - 3х;6) При подозрении на мошеннические действия и при попытках обмана, Slotohub имеет право не начислять бонус или аннулировать бонус.",
      relativeUrl: "welcome",
      externalUrl: "",
      fileUrl: "https://fiat1.securebet.xyz/images/banners/photo_2024-07-13 16.43.43.jpeg",
      mobileFileUrl:
        "https://fiat1.securebet.xyz/images/banners/photo_2024-07-13 16.43.35 (1).jpeg",
      makeBotLink: false
    },
    {
      id: 6,
      name: "",
      position: 3,
      language: "ru",
      gameType: 1,
      gameId: 54,
      bannerText: "",
      relativeUrl: "",
      externalUrl: "",
      fileUrl: "https://fiat1.securebet.xyz/images/banners/IMG_9213.JPEG",
      mobileFileUrl: "https://fiat1.securebet.xyz/images/banners/IMG_9214.jpg",
      makeBotLink: true
    }
  ],
  winnings: {
    changed: "2024-11-13 11:18:09",
    list: [
      {
        gameId: 5772,
        win: 2968
      },
      {
        gameId: 8154,
        win: 2784
      },
      {
        gameId: 3260,
        win: 3525
      },
      {
        gameId: 2776,
        win: 4543
      },
      {
        gameId: 2591,
        win: 1253
      },
      {
        gameId: 4258,
        win: 183
      },
      {
        gameId: 3277,
        win: 2404
      },
      {
        gameId: 2281,
        win: 4531
      },
      {
        gameId: 2586,
        win: 1399
      },
      {
        gameId: 6269,
        win: 4860
      },
      {
        gameId: 994,
        win: 1280
      },
      {
        gameId: 3794,
        win: 796
      },
      {
        gameId: 2255,
        win: 427
      },
      {
        gameId: 1699,
        win: 2110
      },
      {
        gameId: 6238,
        win: 1330
      },
      {
        gameId: 5476,
        win: 3836
      },
      {
        gameId: 805,
        win: 2022
      },
      {
        gameId: 8137,
        win: 4905
      },
      {
        gameId: 3887,
        win: 1420
      },
      {
        gameId: 7475,
        win: 673
      },
      {
        gameId: 142,
        win: 4785
      },
      {
        gameId: 3358,
        win: 2054
      },
      {
        gameId: 6837,
        win: 3163
      },
      {
        gameId: 6911,
        win: 1827
      },
      {
        gameId: 5611,
        win: 3872
      }
    ]
  },
  liveChatData: {
    ru: { propertyId: "6772c3c2af5bfec1dbe4a327", widgetId: "1igc4pckv" },
    en: { propertyId: "678e6d3e3a8427326071b97d", widgetId: "1ikh3ce3g" },
    es: "",
    ar: "",
    az: "",
    uz: ""
  }
};

export const testBalance = {
  RUB: {
    info: {
      decimal: 0,
      type: "fiat",
      current: true
    },
    balances: {
      main: 76924.04,
      payout: 76924.04,
      bonus: 500,
      depositWager: 0,
      bonusWager: 20000
    }
  },
  UZS: {
    info: {
      decimal: 0,
      type: "fiat",
      current: false
    },
    balances: {
      main: 200000,
      payout: 200000,
      bonus: 68000,
      depositWager: 0,
      bonusWager: 2720000
    }
  },
  USDT: {
    info: {
      decimal: 2,
      type: "crypto",
      current: false
    },
    balances: {
      main: 500,
      payout: 500,
      bonus: 0,
      depositWager: 0,
      bonusWager: 0
    }
  }
};

export const testPaymentInfo = {
  currency: "RUB",
  userData: "card",
  bankList: {
    phone: ["sber", "alpha", "tbank", "vtb", "sovcom", "rossel", "yasbp"]
  },
  minAmount: 5000,
  maxAmount: 100000,
  taxPercent: 5,
  taxFixed: 0,
  extraTaxAmount: 10000,
  extraTaxPercent: 10
};

export const testDeposit = {
  currency: "USDT",
  minAmount: 2,
  maxAmount: 50002
};

export const testWelcome = {
  id: 203,
  enabled: true,
  created: "2025-05-27 10:33:00",
  expireDays: 20,
  userActivate: { enabled: true, status: ENUM_USER_ACTIVE.any },
  statusForUser: ENUM_WELCOME_USER_STATUS.disabled,
  activeTo: "2026-09-08 22:13:49",
  useFreeSpinCampaign: true,
  packets: [
    {
      prevPlayedOut: true,
      statusForUser: ENUM_WELCOME_USER_STATUS.accrued,

      values: [
        { minDeposit: 100, maxDeposit: 500, percent: 20, wager: 40, cashout: 5, toDeposit: false },
        {
          minDeposit: 501,
          maxDeposit: null,
          percent: 25,
          wager: 35,
          cashout: null,
          toDeposit: false,
          campaignId: 123
        }
      ]
    },
    {
      prevPlayedOut: false,
      statusForUser: ENUM_WELCOME_USER_STATUS.wait,
      wagerAmount: 1500,
      bonusAmount: 500,
      values: [
        {
          minDeposit: 1001,
          maxDeposit: 1500,
          percent: 30,
          wager: 35,
          cashout: 5,
          toDeposit: false
        },
        {
          minDeposit: 1501,
          maxDeposit: 2000,
          percent: 35,
          wager: 35,
          cashout: 5,
          toDeposit: false
        },
        {
          minDeposit: 1501,
          maxDeposit: 2000,
          percent: 35,
          wager: 35,
          cashout: 5,
          toDeposit: false
        },
        {
          minDeposit: 1501,
          maxDeposit: 2000,
          percent: 35,
          wager: 35,
          cashout: 5,
          toDeposit: false
        }
      ]
    },
    {
      prevPlayedOut: false,
      statusForUser: ENUM_WELCOME_USER_STATUS.disabled,
      values: [
        {
          minDeposit: 1001,
          maxDeposit: 1500,
          percent: 30,
          wager: 35,
          cashout: 5,
          toDeposit: false
        },
        {
          minDeposit: 1501,
          maxDeposit: 2000,
          percent: 35,
          wager: 35,
          cashout: 5,
          toDeposit: false
        }
      ]
    }
  ]
};

export const testCashback = {
  id: 92,
  enabled: true,
  created: "2024-07-20 11:18:36",
  timeZone: 180,
  notAccrue: false,
  lifetimeDays: null,
  useCasinoTax: false,
  statusForUser: "accrued",
  wagerAmount: 15000,
  packets: [
    null,
    {
      toDeposit: false,
      holdDays: 1,
      payoutWeekDay: 1,
      accrualInfo: { date: "2025-06-26 18:31:59", weekDay: 3 },
      statusForUser: ENUM_CASHBACK_STATUS.waitActivate,
      userActivate: { enabled: false, status: ENUM_USER_ACTIVE.any },
      values: [
        { minDeposit: 100, maxDeposit: 200, percent: 20, wager: 30, cashout: null },
        { minDeposit: 100, maxDeposit: 200, percent: 20, wager: 30, cashout: null },
        { minDeposit: 100, maxDeposit: 200, percent: 20, wager: 30, cashout: null },
        { minDeposit: 100, maxDeposit: 200, percent: 20, wager: 30, cashout: null }
      ]
    },
    null,
    {
      toDeposit: false,
      holdDays: 0,
      payoutWeekDay: 0,
      accrualInfo: { date: null, weekDay: null },
      statusForUser: ENUM_CASHBACK_STATUS.waitWeekDay,
      userActivate: { enabled: true, status: ENUM_USER_ACTIVE.any },
      values: [
        { minDeposit: 100, maxDeposit: 200, percent: 20, wager: 30, cashout: null },
        { minDeposit: 100, maxDeposit: 200, percent: 20, wager: 30, cashout: 0 },
        { minDeposit: 100, maxDeposit: 200, percent: 20, wager: 30, cashout: 0 },
        { minDeposit: 100, maxDeposit: 200, percent: 20, wager: 30, cashout: null }
      ]
    },
    null,
    null,
    null
  ]
};

export const testBonus = {
  currency: "RUB",
  registration: {
    toDeposit: true,
    values: {
      amount: 500,
      wager: 2,
      cashout: 3
    }
  },
  firstDeposit: {
    toDeposit: true,
    values: {
      amount: 5001,
      wager: 2,
      cashout: 3,
      minDeposit: 301
    }
  },
  cashback: testCashback,
  startBot: {
    toDeposit: false,
    values: {
      amount: 500,
      wager: 100,
      cashout: 3
    },
    langs: {
      ru: {
        desktop_image: "https://devf.securebet.xyz/images/bonus/171-desktop-hAdTo4hmg0.png",
        mobile_image: ""
      },
      en: {
        desktop_image: "https://devf.securebet.xyz/images/bonus/171-desktop-DnYsO5skok.png",
        mobile_image: ""
      }
    }
  },
  welcome: testWelcome
};

export const testJackpots = {
  list: {
    currency: "EUR",
    grand: {
      amount: 200,
      minBet: 0,
      minDeposit: 0,
      depositDays: 0,
      drop: true
    },
    major: {
      amount: 0,
      minBet: 0,
      minDeposit: 0,
      depositDays: 0,
      drop: false
    },
    mini: {
      amount: 0,
      minBet: 0,
      minDeposit: 0,
      depositDays: 0,
      drop: false
    }
  }
};

export const testCryptoWallet = {
  list: {
    bitcoin: {
      name: "Bitcoin",
      ticker: "BTC"
    },
    "bitcoin-cash": {
      name: "Bitcoin Cash",
      ticker: "BCH"
    },
    litecoin: {
      name: "Litecoin",
      ticker: "LTC"
    },
    monero: {
      name: "Monero",
      ticker: "XMR"
    },
    tron: {
      name: "Tron",
      ticker: "TRX"
    }
  }
};

export const testCryptogateInfo = {
  address: "bitcoincash:qp88zfqmguwfc69updja922th2kpxs0rq5r25eqvm4",
  wallet: {
    name: "Bitcoin Cash",
    ticker: "BCH"
  }
};

export const testDetailBalance = {
  openForPayout: 4314.4,
  depositBalance: [
    { amount: 1000, wager: 2, remained: 2000 },
    { amount: 150, wager: 5, remained: 750 },
    { amount: 293354, wager: 40, remained: 253632 }
  ],
  bonusBalance: [
    { amount: 68.64, wager: 10, cashout: 3, remained: 686.43 },
    { amount: 18.64, wager: 5, cashout: 2, remained: 386.43 }
  ]
};

export const testFreeSpins = [
  {
    id: 316,
    enabled: true,
    created: "2025-10-09 11:15:06",
    name: "Бесплатный октябрь ",
    currency: "RUB",
    activated: null,
    expired: null,
    timeZone: 180,
    status: "active",
    activatedCount: 0,
    usedCount: 0,
    updateLocked: false,
    campaigns: [
      {
        stepNo: 0,
        minDeposit: 500,
        maxDeposit: 10000000,
        campaignId: 17
      }
    ],
    statusForUser: "enabled",
    userActivate: {
      enabled: true,
      status: "wait"
    }
  },
  {
    id: 317,
    enabled: false,
    created: "2025-10-09 11:23:05",
    name: "e",
    currency: "RUB",
    activated: "2025-10-09 00:00:00",
    expired: "2025-10-16 23:59:59",
    timeZone: 180,
    status: "deleted",
    activatedCount: 0,
    usedCount: 0,
    updateLocked: false,
    campaigns: [
      {
        stepNo: 0,
        minDeposit: 45,
        maxDeposit: 455,
        campaignId: 17
      }
    ],
    statusForUser: "disabled",
    userActivate: {
      enabled: false,
      status: "any"
    }
  },
  {
    id: 318,
    enabled: false,
    created: "2025-10-09 11:23:26",
    name: "e",
    currency: "RUB",
    activated: "2025-10-09 00:00:00",
    expired: "2025-10-16 23:59:59",
    timeZone: 180,
    status: "deleted",
    activatedCount: 0,
    usedCount: 0,
    updateLocked: false,
    campaigns: [
      {
        stepNo: 0,
        minDeposit: 45,
        maxDeposit: 455,
        campaignId: 17
      },
      {
        stepNo: 1,
        minDeposit: 4,
        maxDeposit: 4444,
        campaignId: 17
      }
    ],
    statusForUser: "disabled",
    userActivate: {
      enabled: false,
      status: "any"
    }
  },
  {
    id: 319,
    enabled: false,
    created: "2025-10-09 11:26:28",
    name: "rer",
    currency: "RUB",
    activated: "2025-10-09 00:00:00",
    expired: "2025-10-16 23:59:59",
    timeZone: 180,
    status: "deleted",
    activatedCount: 0,
    usedCount: 0,
    updateLocked: false,
    campaigns: [
      {
        stepNo: 0,
        minDeposit: 4,
        maxDeposit: 444,
        campaignId: 17
      }
    ],
    statusForUser: "disabled",
    userActivate: {
      enabled: false,
      status: "any"
    }
  },
  {
    id: 320,
    enabled: true,
    created: "2025-10-09 11:38:19",
    name: "хэлуин",
    currency: "RUB",
    activated: null,
    expired: null,
    timeZone: 180,
    status: "active",
    activatedCount: 0,
    usedCount: 0,
    updateLocked: false,
    campaigns: [
      {
        stepNo: 0,
        minDeposit: 12,
        maxDeposit: 10000,
        campaignId: 17
      }
    ],
    statusForUser: "enabled",
    userActivate: {
      enabled: true,
      status: "wait"
    }
  }
];

export const testCampaignInfo = {
  name: "test 09.10",
  currency: "RUB",
  deleted: false,
  games: [
    {
      gameId: 26,
      freespinId: "3645054d-00000017-00000026",
      name: "Gryphons' Gold Deluxe",
      image: "https://r.gamesstatic.com/games/e6601195efc82f389ecd755ddefcffce6da483d6.jpg",
      bet: { betId: 5, totalBet: 10, lines: 0 },
      freespins: 10,
      wager: 10,
      cashout: 10
    },
    {
      gameId: 56,
      freespinId: "d262af8e-00000017-00000056",
      name: "Book Of Ra",
      image: "https://stage.gamesstatic.com/games/b7019ffb9b1f4579a0ca79f11c9ec90ea1d999eb.jpg",
      bet: {
        betId: 4,
        totalBet: 4.5,
        lines: 0
      },
      freespins: 5,
      wager: 5,
      cashout: 5
    },
    {
      gameId: 124,
      freespinId: "579a3b4f-00000017-00000124",
      name: "Sizzling Hot Deluxe",
      image: "https://r.gamesstatic.com/games/557af416d9831dccc0bd5fdfe47eaa41c60015ad.jpg",
      bet: {
        betId: 13,
        totalBet: 250,
        lines: 0
      },
      freespins: 20,
      wager: 50,
      cashout: 30
    }
  ]
};
